module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.19.9047a9d1.png";